// AUTH-07 Accept invitation, from the emailed link (?token=).
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Button, Form } from "react-aria-components";
import { api, call } from "../../api/client";
import { describeError } from "../../api/errors";
import { session, type AuthSession } from "../../api/session";
import { Banner } from "../../components/Banner";
import { AuthLayout } from "./AuthLayout";
import { Field, takeTokenFromUrl } from "./fields";

export function AcceptInvitation() {
  const navigate = useNavigate();
  const [token] = useState(takeTokenFromUrl);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!token) {
    return (
      <AuthLayout title="Accept your invitation">
        <Banner tone="warning">This page needs the link from your invitation email.</Banner>
      </AuthLayout>
    );
  }

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      const res = await call(api.POST("/auth/invitations/accept", { body: { token: token!, password, ...(name ? { display_name: name } : {}) } }));
      await session.start(res as AuthSession);
      void navigate({ to: "/" });
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout title="Accept your invitation">
      <p>Choose a password to finish setting up your account.</p>
      {error && <Banner tone="critical">{error}</Banner>}
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <Field label="Your name" name="display_name" autoComplete="name" value={name} onChange={setName} autoFocus />
        <Field label="Password" type="password" name="password" autoComplete="new-password" minLength={12} maxLength={128} isRequired value={password} onChange={setPassword} />
        <Button type="submit" className="button primary wide" isPending={busy}>
          Accept and sign in
        </Button>
      </Form>
    </AuthLayout>
  );
}
